const /*CH_COMMA=0, CH_BACKSLASH=1, CH_OPENBRACE=2, CH_CLOSEBRACE=3, */ CH_ENDSTREAM = 4,
  CH_OTHER = 5;
const T_SUCCESS = 0,
  T_FAIL = 1,
  T_KEY = 2,
  T_VALUE = 3,
  T_START = 4,
  T_END = 5;
let transitionTable = {
  KEYSTART: [
    ['FAIL', ''],
    ['FAIL', ''],
    ['FAIL', ''],
    ['ENDVAL', 'Q'],
    ['FAIL', ''],
    ['KEYTEXT', 'K'],
  ],
  KEYTEXT: [
    ['FAIL', ''],
    ['LITERAL', ''],
    ['KEYSTART', 'S'],
    ['FAIL', ''],
    ['FAIL', ''],
    ['VALTEXT', 'A'],
  ],
  VALTEXT: [
    ['KEYSTART', 'V'],
    ['LITERAL', ''],
    ['FAIL', ''],
    ['ENDVAL', 'Q'],
    ['SUCCESS', 'V'],
    ['VALTEXT', 'A'],
  ],
  ENDVAL: [
    ['KEYSTART', ''],
    ['FAIL', ''],
    ['FAIL', ''],
    ['ENDVAL', 'E'],
    ['SUCCESS', ''],
    ['KEYTEXT', 'K'],
  ],
  LITERAL: [
    ['VALTEXT', 'A'],
    ['VALTEXT', 'A'],
    ['VALTEXT', 'A'],
    ['VALTEXT', 'A'],
    ['FAIL', ''],
    ['VALTEXT', 'A'],
  ],
};

export function charClass(ch) {
  let charClass = ',\\[]'.indexOf(ch);
  if (charClass < 0) charClass = CH_OTHER;
  return charClass;
}

export function* parser(data) {
  let context = '',
    key,
    value,
    group;
  for (let token of tokenizer(data)) {
    switch (token[0]) {
      case T_FAIL:
        throw 'Failed!';
      case T_START:
        context += key;
        key = '';
        break;
      case T_END:
        {
          let len = context.length;
          context = context.slice(0, len - 1);
          key = '';
          value = '';
        }
        break;
      case T_KEY:
        key = token[1];
        break;
      case T_VALUE:
        {
          value = token[1];
          let ck = context + key;
          group = key === 'L' && group !== value ? value : group;
          yield { ck, context, key, value, group };
        }
        break;
    }
  }
}

export function* tokenizer(chars) {
  let state = 'KEYSTART';
  let accumulator = '';
  for (let ch of chars) {
    let [nextstate, action] = transitionTable[state][charClass(ch)];
    switch (action) {
      case 'A':
        accumulator += ch;
        break;
      case 'K':
        yield [T_KEY, ch];
        break;
      case 'V':
        yield [T_VALUE, accumulator];
        accumulator = '';
        break;
      case 'S':
        yield [T_START];
        break;
      case 'E':
        yield [T_END];
        break;
      case 'Q':
        yield [T_VALUE, accumulator];
        accumulator = '';
        yield [T_END];
        break;
    }
    state = nextstate;
    if (state === 'FAIL') return [T_FAIL];
  }
  if (accumulator !== '') {
    yield [T_VALUE, accumulator];
    yield [T_END];
  }
  let [nextstate] = transitionTable[state][CH_ENDSTREAM];
  return nextstate === 'FAIL' ? [T_FAIL] : [T_SUCCESS];
}

export function processResults(data) {
  let nameAndType = {
    N: { text: 'Name', datatype: 'string' },
    D: { text: 'Description', datatype: 'string' },
    T: { text: 'Tool', datatype: 'string' },
    V: { text: 'Version', datatype: 'string' },
    C: { text: 'CreatedDate', datatype: 'datetime' },
    U: { text: 'UpdatedDate', datatype: 'datetime' },
    // designData level
    d: { text: 'Design', datatype: 'object' },
    dv: { text: 'visitedTabs', datatype: 'visitedTabs' },
    df: { text: 'filterType', datatype: 'filterType' },
    // specifications
    ds: { text: 'specifications', datatype: 'object' },
    dsg: { text: 'gain', datatype: 'number' },
    dsu: { text: 'gainUnit', datatype: 'gainUnit' },
    dsa: { text: 'passbandAttenuation', datatype: 'number' },
    dsf: { text: 'passbandFrequency', datatype: 'number' },
    dsA: { text: 'stopbandAttenuation', datatype: 'number' },
    dsF: { text: 'stopbandFrequency', datatype: 'number' },
    dsc: { text: 'centerFrequency', datatype: 'number' },
    dsr: { text: 'filterResponseValue', datatype: 'number' },
    dsR: { text: 'filterResponseSlider', datatype: 'number' },
    // components
    dc: { text: 'components', datatype: 'object' },
    dcp: { text: 'vsPlus', datatype: 'number' },
    dcm: { text: 'vsMinus', datatype: 'number' },
    dco: { text: 'optimization', datatype: 'optimizationEnumeration' },
    dcO: { text: 'optimizationPreference', datatype: 'optimizationPreferenceEnumeration' },
    dcc: { text: 'compensateForGbw', datatype: 'boolean' },
    dcr: { text: 'recommendedAmp', datatype: 'string' },
    dcR: { text: 'referenceVoltage', datatype: 'number' },
    dcS: { text: 'sortOrder', datatype: 'sortOrder' },
    dca: { text: 'preferredAlgorithms', datatype: 'object' },
    dcas: { text: 'sallenKey|lowPass', datatype: 'preferredAlgorithmsEnumeration' },
    // stages
    dcs: { text: 'stage', datatype: 'object' },
    dcsL: { text: 'stageLetter', datatype: 'string' },
    dcss: { text: 'componentSizing', datatype: 'number' },
    dcsg: { text: 'gain', datatype: 'number' },
    dcsG: { text: 'gainEnabled', datatype: 'boolean' },
    dcsi: { text: 'implementation', datatype: 'implementationEnumeration' },
    dcso: { text: 'opAmps', datatype: 'string' },
    // tolerances
    dt: { text: 'tolerances', datatype: 'object' },
    dtr: { text: 'resistorTolerance', datatype: 'tolerances' },
    dtc: { text: 'capacitorTolerance', datatype: 'tolerances' },
    dtl: { text: 'inductorTolerance', datatype: 'tolerances' },
    dtg: { text: 'opAmpGbwTolerance', datatype: 'tolerances' },
    dtR: { text: 'resistorPreferredSeries', datatype: 'string' },
    dtC: { text: 'capacitorPreferredSeries', datatype: 'string' },
    dtL: { text: 'inductorPreferredSeries', datatype: 'string' },
    // next-steps
    dn: { text: 'nextSteps', datatype: 'object' },
  };
  let result = [],
    sortOrder = [],
    sortIndex = -1,
    sortContext = '',
    sortName = '';
  data.forEach((d, i) => {
    let n = nameAndType[d.context + d.key],
      name = n.text,
      value = d.value,
      type = n.datatype;
    if (name === 'sortOrder') {
      if (sortOrder.length === 0) {
        sortContext = d.context;
        sortName = name;
        sortIndex = i;
      }
      if (sortContext === d.context && sortName === name) sortOrder.push(parseInt(value));
    } else {
      result.push({ context: d.context, name: name, value: processValue(value, type), group: d.group });
    }
  });
  result.splice(sortIndex, 0, { context: sortContext, name: sortName, value: sortOrder, group: '' });
  return result;
}

export function generateJsonString(data) {
  let result = [],
    designData = [],
    specifications = [],
    components = [],
    tolerances = [],
    nextSteps = [],
    stages = [];
  let group = [];
  let algopreferences = {};
  data.forEach((d) => {
    switch (d.context) {
      case 'd':
        designData[d.name] = d.value;
        break;
      case 'ds':
        specifications[d.name] = d.value;
        break;
      case 'dc':
        components[d.name] = d.value;
        break;
      case 'dt':
        tolerances[d.name] = d.value;
        break;
      case 'dn':
        nextSteps[d.name] = d.value;
        break;
      case 'dcs':
        if (!group.includes(d.group)) {
          group.push(d.group);
        }
        stages[`${d.group}.${d.name}`] = d.value;
        break;
      case 'dca':
        algopreferences[d.name] = d.value;
        break;
      case '':
      default:
        result[d.name] = d.value;
        break;
    }
  });
  designData['specifications'] = Object.assign({}, specifications);
  components['stages'] = processStages(stages, group);
  if (Object.keys(algopreferences).length !== 0 && algopreferences.constructor === Object) {
    // Never set anything here if it is empty
    components['preferredAlgorithms'] = algopreferences;
  }
  components['recommendedAmps'] = [];
  designData['components'] = Object.assign({}, components);
  designData['tolerances'] = Object.assign({}, tolerances);
  designData['nextSteps'] = Object.assign({}, nextSteps);
  result['Design'] = Object.assign({}, designData);
  return JSON.stringify(Object.assign({}, result), null, '\t');
}

// INTERNAL FUNCTIONS
const VisitedTabsEnumeration = {
  f: 'filter-type',
  s: 'specifications',
  c: 'components',
  t: 'tolerances',
  n: 'next-steps',
};
const FilterTypeEnumeration = { l: 'lowPass', h: 'highPass', b: 'bandPass' };
const GainUnitEnumeration = { v: 'V/V', d: 'dB' };
const OptimizationEnumeration = { p: 'Power', n: 'Noise', v: 'VoltageRange', r: 'RecommendedSpecificComponents' };
const OptimizationPreferenceEnumeration = { n: 'nonSpecific', s: 'specific' };
const ImplementationEnuemartion = {
  s: 'sallenKey',
  m: 'multipleFeedback',
  i: 'inductor',
  d: 'deliyannisFriend',
  f: 'firstOrder',
};
const ToleranceEnumeration = { O: '1%', F: '5%', T: '10%', W: '20%', i: 'ideal', o: '0.1%', f: '0.5%' };
const PreferredAlgorithmsEnumeration = { L1: 'lowpass', L2: 'lowpassV2' };

function processValue(value, type) {
  switch (type) {
    case 'string':
      return value;
    case 'boolean':
      return processBoolean(value);
    case 'number':
      return parseFloat(value);
    case 'datetime':
      return processDate(value);
    case 'visitedTabs':
      return processFieldSet(value, VisitedTabsEnumeration); // return processVisitedTabs(value);
    case 'sortOrder':
      return processSortOrder(value);
    case 'filterType':
      return processEnumeration(value, FilterTypeEnumeration); // processFilterType(value);
    case 'gainUnit':
      return processEnumeration(value, GainUnitEnumeration); // processGainUnit(value);
    case 'optimizationEnumeration':
      return processEnumeration(value, OptimizationEnumeration); // processOptimizationEnum(value);
    case 'optimizationPreferenceEnumeration':
      return processEnumeration(value, OptimizationPreferenceEnumeration); // processOptimizationPreferenceEnum(value);
    case 'implementationEnumeration':
      return processEnumeration(value, ImplementationEnuemartion); // processImplementationEnum(value);
    case 'preferredAlgorithmsEnumeration':
      return processEnumeration(value, PreferredAlgorithmsEnumeration);
    case 'tolerances':
      return processEnumeration(value, ToleranceEnumeration); // processTolerances(value);
    default:
      return value;
  }
}

function processBoolean(value) {
  return parseInt(value) === 1 ? true : false;
}

function processDate(dtString) {
  let year = dtString.slice(0, 4),
    month = dtString.slice(4, 6),
    day = dtString.slice(6, 8),
    hour = dtString.slice(8, 10),
    minutes = dtString.slice(10, 12),
    seconds = dtString.slice(12),
    hour12 = parseInt(hour) >= 12 ? '0'.concat(parseInt(hour) - 12).slice(-2) : hour,
    period = parseInt(hour) >= 12 ? 'PM' : 'AM';
  return `${year}-${month}-${day} ${hour12}:${minutes}:${seconds} ${period}`;
}

function processSortOrder(value) {
  let result = [];
  [...value].forEach((d) => {
    result.push(parseInt(d));
  });
  return result;
}

function processStages(stages, group) {
  let result = [];
  group.forEach((g) => {
    let stage = [];
    for (let key in stages) {
      if (key.indexOf(`${g}.`) > -1) {
        stage[key.slice(2)] = stages[key];
      }
    }
    result.push(Object.assign({}, stage));
  });
  return result;
}

function processEnumeration(value, table) {
  return value in table ? table[value] : null;
}

function processFieldSet(value, table) {
  let anyMisfires = false;
  let result = [...value].map((item) => {
    if (!(item in table)) anyMisfires = true;
    return item in table ? table[item] : null;
  });
  return anyMisfires ? null : result;
}
